import { Form, Input, Row } from "antd"
import React from "react"
import Banners from "./Banners"
import S3Upload from "@a4b/ui/src/modules/monetisation/puja/molecules/S3Upload"

interface Props {
    cdnUrl: string
    preSignUrl: string
    type: string
    basePath?: any
    restFields?: any
}

const InfluencerRecommendationBanner: React.FC<Props> = ({ cdnUrl, preSignUrl, type, basePath, restFields }) => {
    return (
        <>
            <Form.Item
                {...restFields}
                label={`Title`}
                name={[...basePath, 'influencer_recommendation_banner', 'title']}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                style={{ flexBasis: '40%' }}
                rules={[
                    {
                        required: false,
                        message: 'Enter Title',
                    },
                ]}
            >
                <Input placeholder='Enter Title' />
            </Form.Item>

            <Form.Item
                label={`Description`}
                name={[...basePath, 'influencer_recommendation_banner', 'description']}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                style={{ flexBasis: '45%' }}
                rules={[
                    {
                        required: false,
                        message: 'Enter description',
                    },
                ]}
            >
                <Input placeholder='Please type Description' />
            </Form.Item>
            <Form.Item
                label="Icon Url"
                name={[...basePath, 'influencer_recommendation_banner', 'icon_url']}
                labelCol={{ span: 24 }}
                rules={[
                    {
                        required: true,
                        min: 1,
                        max: 1,
                        validator: async (rules: any, values: any) => {
                            if (values?.length < rules.min) {
                                return Promise.reject('Please upload Media')
                            }
                        },
                    },
                ]}
                valuePropName="fileList"
            >
                <S3Upload
                    cdnUrl={cdnUrl}
                    preSignUrl={preSignUrl}
                    min={1}
                    max={1}
                />
            </Form.Item>
            <Form.List name={[...basePath, 'influencer_recommendation_banner', 'stores_list']}>
                {(fields, { add, remove, move }) => (
                    <>
                        <Row justify="space-between" style={{ width: '100%' }}>
                            <Banners
                                onSortEnd={({ oldIndex, newIndex }) => {
                                    console.log('oldIndex', oldIndex, 'newIndex', newIndex)
                                    move(oldIndex, newIndex)
                                }}
                                distance={1}
                                helperClass='sortableHelper'
                                fields={fields}
                                add={add}
                                remove={remove}
                                cdnUrl={cdnUrl}
                                preSignUrl={preSignUrl}
                                datatype='Influencer Recommendation Banner'
                            />
                        </Row>
                    </>
                )}
            </Form.List>
        </>
    )
}

export default InfluencerRecommendationBanner